<div class=" modal-content">
    
    <h1 class="panel-title position-relative">
        {{data.msg}}<button  type="button" aria-label="Close" class="close" mat-dialog-close><span _ngcontent-dns-c405="" aria-hidden="true">×</span></button>
    </h1>
    <div class="file-drop-wrapper" appDrag fileType='application/vnd.openxmlformats' (files)="filesDropped($event)">
        <span width="100%" class="upload-text" *ngIf="excelFile!==null">{{excelFile.name}}
                <em class="fas fa-trash-alt cursor" (click)="excelFile=null;fileUpload.value = ''"></em>
            </span>
        <input id="uploadCaptureInputFile" #fileUpload type="file" style="display: none;"
            (change)="uploadFile($event)" accept=".xlsx,.xls">
        <span width="100%" class="upload-link" (click)="fileUpload.click()" *ngIf="excelFile===null">
           <a class="cursor">Browse/Drag and drop file(.xlsx)</a>
        </span>
    </div>
    <div class="template" *ngIf="downloadTemplate">
        <a [href]="downloadTemplate" download>Download sample template</a>
    </div>
    <div class="btn-basket">
        <button mat-button mat-dialog-close class="mat-focus-indicator mat-raised-button mat-button-base mat-primary">Cancel</button>
        <button mat-button  [hidden]="!excelFile" (click)="dialogSubmit()" class="mat-focus-indicator mat-raised-button mat-button-base mat-primary">Upload</button>
    </div>
</div>